<!-- TODO remove or revise colons ":" 'cause of translations -->
<cmps-dialog>
    <cmps-dialog-body>
        <cmps-wait-status *ngIf="_hasPendingData === true"></cmps-wait-status>
        <div *ngIf="_hasPendingData !== true && _userProfile == null">
            {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
        </div>
        <div
            class="cmps-cdk-text-left"
            *ngIf="_hasPendingData !== true && _userProfile != null"
        >
            <div class="cmps-cdk-mb-0dot5">
                <div class="cmps-cdk-d-inline-block cmps-cdk-font-bold">
                    {{ _i18n._67_SUPERGROUP | translate }}:&nbsp;
                </div>
                <div class="cmps-cdk-d-inline-block">
                    {{ _userProfile?.superGroup?.superGroupName }}
                </div>
            </div>
            <div class="cmps-cdk-mb-0dot5">
                <div class="cmps-cdk-d-inline-block cmps-cdk-font-bold">
                    {{ _i18n._7374_DAYS_IN_SUPERGROUP | translate }}:&nbsp;
                </div>
                <div class="cmps-cdk-d-inline-block">
                    {{
                        _userProfile?.profile?.superGroupAge
                            | cmpsNumber: '1.0-0'
                    }}
                </div>
            </div>
            <div class="cmps-cdk-mb-0dot5">
                <div class="cmps-cdk-d-inline-block cmps-cdk-font-bold">
                    {{ _i18n._48_MANAGER | translate }}:&nbsp;
                </div>
                <div
                    class="cmps-cdk-d-inline-block"
                    *ngIf="_userProfile?.manager?.userId == null"
                >
                    {{ _i18n._842_N_A | translate }}
                </div>
                <div
                    class="cmps-cdk-d-inline-block"
                    *ngIf="_userProfile?.manager?.userId != null"
                >
                    {{
                        _userProfile?.manager?.firstName?.trim() +
                            ' ' +
                            _userProfile?.manager?.lastName?.trim()
                    }}
                </div>
            </div>
            <div class="cmps-cdk-mb-0dot5">
                <div class="cmps-cdk-d-inline-block cmps-cdk-font-bold">
                    {{
                        _i18n._11275_DAYS_REPORTING_TO_MANAGER | translate
                    }}:&nbsp;
                </div>
                <div
                    class="cmps-cdk-d-inline-block"
                    *ngIf="_userProfile?.manager?.userId == null"
                >
                    {{ _i18n._842_N_A | translate }}
                </div>
                <div
                    class="cmps-cdk-d-inline-block"
                    *ngIf="_userProfile?.manager?.userId != null"
                >
                    {{
                        _userProfile?.profile?.managerAge | cmpsNumber: '1.0-0'
                    }}
                </div>
            </div>
            <div>
                <div class="cmps-cdk-d-inline-block cmps-cdk-font-bold">
                    {{ _i18n._59_ROLE | translate }}:&nbsp;
                </div>
                <div class="cmps-cdk-d-inline-block">
                    {{ _userProfile?.role?.roleName }}
                </div>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
